import { AiFillDislike, AiFillLike } from "react-icons/ai";
import { BiDislike, BiLike } from "react-icons/bi";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";

/**
 * Like / dislike / bookmark buttons driven by useMediaActions.
 * Like and dislike hide each other, matching the original behaviour.
 */
const ReactionBar = ({
  actions,
  showReactions = true,
  showBookmark = true,
  size = "text-2xl md:text-3xl",
  className = "",
}) => {
  const {
    liked,
    disliked,
    bookmarked,
    toggleLike,
    toggleDislike,
    toggleBookmark,
  } = actions;
  const button = `cursor-pointer text-gray-300 transition hover:text-white ${size}`;

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {showBookmark && (
        <button type="button" onClick={toggleBookmark} aria-label="نشان کردن">
          {bookmarked ? (
            <FaBookmark className={button} />
          ) : (
            <FaRegBookmark className={button} />
          )}
        </button>
      )}

      {showReactions && !disliked && (
        <button type="button" onClick={toggleLike} aria-label="پسندیدن">
          {liked ? (
            <AiFillLike className={button} />
          ) : (
            <BiLike className={button} />
          )}
        </button>
      )}

      {showReactions && !liked && (
        <button type="button" onClick={toggleDislike} aria-label="نپسندیدن">
          {disliked ? (
            <AiFillDislike className={button} />
          ) : (
            <BiDislike className={button} />
          )}
        </button>
      )}
    </div>
  );
};

export default ReactionBar;
